/// <amd-module name="typeahead/core/RequestGenerator" />
/// <amd-dependency path="jquery" name="$"/>

import {DefaultPluginAssembly} from "typeahead/core/plugins/DefaultPluginAssembly";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

export abstract class RequestGenerator implements IRequestGenerator {

    public static ESS_ABACUS_IDS: string[] = [];

    public static defaultVariantAssigner(abacusId?: string): string {
        // if(searchExperiments){
        //     return searchExperiments.getSearchExperimentVariantIfParticipating;
        // }
        return undefined;
    }

    public essAbacusIds: string[];
    public variantAssigner: (id?: string) => string;
    public requestParamModifiers: IRequestUrlParamModifier[] = [];
    public suggestServiceUrlOptions: ISuggestServiceUrlOptions;

    constructor(essAbacusIds: string[], variantAssigner: (id?: string) => string,
                suggestServiceUrlOptions: ISuggestServiceUrlOptions, siteid: string, pluginAssembly: IPluginAssembly) {
        this.essAbacusIds = essAbacusIds;
        this.variantAssigner = variantAssigner;
        this.suggestServiceUrlOptions = suggestServiceUrlOptions;
        if (pluginAssembly) {
            this.requestParamModifiers = pluginAssembly.get(DefaultPluginAssembly.requestParamModifierIdentifier);
        }
    }

    public getVariantAssignment(abacusId: string): string {
        if (typeof this.variantAssigner !== "function") {
            return undefined;
        }
        const variant = this.variantAssigner(abacusId);
        return variant === undefined ? undefined : "".concat(abacusId, ".", variant);
    }

    public generateAbacusParameter(): string {
        const self = this;
        const abFieldValue = [];

        function getVariantAssignment(abacusId) {
            if (typeof self.getVariantAssignment === "function") {
                return self.getVariantAssignment(abacusId);
            } else {
                return undefined;
            }
        }

        $(this.essAbacusIds).each((index, abId) => {
            const variantAssignment = getVariantAssignment(abId);
            if (variantAssignment) {
                abFieldValue.push(variantAssignment);
            }
        });

        return abFieldValue.length > 0 ? abFieldValue.join("|") : "";
    }

    public constructEssUrl(srchText: string): string {
        let suggestServiceUrl = this.suggestServiceUrlOptions.suggestServiceUrl;
        if (this.suggestServiceUrlOptions.overrideServiceUrl) {
            suggestServiceUrl = [
                this.suggestServiceUrlOptions.overrideServiceUrl,
                encodeURIComponent(srchText),
            ].join("");
        } else {
            suggestServiceUrl = [
                this.suggestServiceUrlOptions.serviceUrl,
                "/api/v4/typeahead/",
                encodeURIComponent(srchText),
                "?callback=?",
            ].join("");
        }
        return suggestServiceUrl;
    }

    public constructEgtaUrl(srchText: string): string {
        return [
            this.suggestServiceUrlOptions.serviceUrl,
            "/egta/api/v4/typeahead/",
            encodeURIComponent(srchText),
            "?",
        ].join("");
    }

    public abstract makeRequest(srchText: string, options: any, context: IContext): JQueryPromise<any>;
}

/**
 * Function to allow the caller to provide the version of jQuery they want to use
 * and not rely on the page load time AMD module loader to provide one. This facilitates
 * unit testing so you can mock/stub/fake the jQuery functionality used in here.
 * @param jQuery
 */
export function overrideJQuery(jQuery: JQueryStatic): void {
    $ = jQuery;
}
